goog.provide("shadow.js.shim.module$date_fns$locale$fa_IR$default");
shadow.js.shim.module$date_fns$locale$fa_IR$default = esm_import$date_fns$locale$fa_IR.default;
